export enum RecoilAtomKeys {
  API_CLIENT_STATE = 'apiClientState',
}

export enum RecoilSelectorKeys {}
